import cn from 'clsx'
import { FC } from 'react'

import { Button, Typography } from '@/components/ui'

interface ICopyTollbarProps {
	handleCopyAll: () => void
	handleCopyText: () => void
	isTranslateLoading?: boolean
}

const CopyToolbar: FC<ICopyTollbarProps> = ({
	handleCopyAll,
	handleCopyText,
	isTranslateLoading
}) => {
	return (
		<div className='flex gap-2 items-center'>
			<Typography variant='text' className='!text-[12px] !leading-[16px]'>
				Copy
			</Typography>
			<div className='flex gap-1'>
				<Button
					disabled={isTranslateLoading}
					className={cn(
						'!h-fit !py-[6px] !px-[14px] bg-gray-100 hover:bg-gray-200 active:bg-gray-400 active:scale-y-90 !text-black rounded-[4px]'
					)}
					classNameText='!text-[12px] !leading-[16px]'
					onClick={handleCopyAll}
				>
					All
				</Button>
				<Button
					disabled={isTranslateLoading}
					className={cn(
						'!h-fit !py-[6px] !px-[14px] bg-gray-100 hover:bg-gray-200 active:bg-gray-400 active:scale-y-90 !text-black rounded-[4px]'
					)}
					classNameText='!text-[12px] !leading-[16px]'
					onClick={handleCopyText}
				>
					Text
				</Button>
			</div>
		</div>
	)
}

export default CopyToolbar
